export const visibleWhen = (
  visibleWhenDict: { [id: string]: string[] } | undefined,
  data: Partial<Record<string, string>>
) => {
  return !!visibleWhenDict && Object.keys(visibleWhenDict).length > 0
    ? Object.keys(visibleWhenDict).filter(
        (key) => visibleWhenDict[key]?.indexOf(data[key] === undefined ? 'false' : data[key]!) >= 0
      ).length >= Object.keys(visibleWhenDict).length
    : true
}

export const enabledWhen = (
  enabledWhenDict: { [id: string]: string[] } | undefined,
  data: Partial<Record<string, string>>
) => {
  return !!enabledWhenDict && Object.keys(enabledWhenDict).length > 0
    ? Object.keys(enabledWhenDict).filter(
        (key) => enabledWhenDict[key]?.indexOf(data[key] === undefined ? 'false' : data[key]!) >= 0
      ).length >= Object.keys(enabledWhenDict).length
    : true
}
